import { render } from "./LanguageIcon.vue?vue&type=template&id=28e80572&scoped=true"
import script from "./LanguageIcon.vue?vue&type=script&lang=js"
export * from "./LanguageIcon.vue?vue&type=script&lang=js"

import "./LanguageIcon.vue?vue&type=style&index=0&id=28e80572&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e80572"]])

export default __exports__